import { render, staticRenderFns } from "./DashboardKeyMetrics.vue?vue&type=template&id=d69544a2"
import script from "./DashboardKeyMetrics.vue?vue&type=script&lang=js"
export * from "./DashboardKeyMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports